import { FindSeatData } from "../../pages/SeatsPage/helpers";
import { isAgent, pushEvent } from "./pushEvent";

export function pushSelectSeatEvent({addedSeats, currency}: {addedSeats: FindSeatData[], currency: string}) {
  
  if(isAgent()) return;

  if(!Array.isArray(addedSeats) || addedSeats.length === 0) return;

  const items = addedSeats.map(s => {
    const { seat } = s;

    return {
      item_id: `${seat.serviceCode}`,
      item_name: `${seat.rowNumber}${seat.seatNumber}`,
      item_category: 'seat',
      price: seat.amount,
      quantity: 1
    }
  })

  const data = {
    currency,
    value: items.reduce((acc, item) => acc + item.price, 0),
    items
  }

  pushEvent({ event: 'add_to_cart', data})
}